const getOrderLineDosTo2 = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      const date = indexOrderLine['Date of Service To'] || indexOrderLine.dateOfServiceTo;
      return date.replace(/[/]/g, '').substring(2, 4);
    }

    return null;
  }

  return orderLine
    ? orderLine.map((item) => {
      const date = item['Date of Service To'] || item.dateOfServiceTo;
      return date.replace(/[/]/g, '').substring(2, 4);
    }).join(', ')
    : null;
};

export default getOrderLineDosTo2;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDosTo2.js